import { css } from "lit";

export const styles = css`
  .form-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 16px;
    max-height: 80vh;
    overflow-y: auto;
  }

  .form-row {
    display: flex;
    gap: 16px;
    align-items: flex-start;
  }

  .form-row > * {
    flex: 1;
  }

  .background-images-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .background-images-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media (max-width: 768px) {
    .form-row {
      flex-direction: column;
    }

    .background-images-grid {
      grid-template-columns: 1fr;
    }
  }
`;
